import Vue from 'vue'
import Vuex from 'vuex'
import pathify from "vuex-pathify";

import dashboard from "./store/modules/dashboard.js";
import customer from "./store/modules/customer.js";
import payMethods from "./store/modules/payMethods.js";
import authentication from "./store/modules/authentication.js";
import config from "./store/modules/config.js";
import i18nStore from "./store/modules/i18nStore.js";
import order from "./store/modules/order.js";
import pallet from "./store/modules/pallet.js";
import carrier from "./store/modules/carrier.js";
import product from "./store/modules/product.js";
import event from "./store/modules/event.js";
import label from "./store/modules/label.js";
import field from "./store/modules/field.js";
import fieldSite from "./store/modules/fieldSite.js";
import producer from "./store/modules/producer.js";
import campaign from "./store/modules/campaign.js";
import variable from "./store/modules/variable.js";
import supplier from "./store/modules/supplier.js";
import researchOrder from "./store/modules/researchOrder.js";
import user from "./store/modules/user.js";
import exportXls from "./store/modules/exportXls.js";
import silo from "./store/modules/silo.js";
import stockHistory from "./store/modules/stockHistory.js";



Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    globalFieldSite: {},
    globalCampaign: {},
  },
  mutations: {
    updateGlobalFieldSite(state, payload){
      state.globalFieldSite = payload;
    },
    updateGlobalCampaign(state, payload){
      state.globalCampaign = payload;
    },
  },
  actions: {
  },
  plugins: [
    pathify.plugin
  ],
  modules: {
    authentication,
    dashboard,
    customer,
    config,
    payMethods,
    i18nStore,
    order,
    pallet,
    carrier,
    product,
    event,
    label,
    field,
    fieldSite,
    producer,
    campaign,
    variable,
    supplier,
    researchOrder,
    user,
    exportXls,
    silo,
    stockHistory,
    
  }
})
